import {
	Component,
	Inject,
	AfterRenderPhase,
	PLATFORM_ID,
	afterNextRender,
	inject,
	OnInit,
} from '@angular/core';
import {
	isPlatformBrowser
} from '@angular/common';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
	selector: 'app',
	templateUrl: './app.pug',
})
export class AppComponent implements OnInit {

	private readonly _router = inject( Router );

	constructor(
		@Inject(PLATFORM_ID) private _platformId: Object,
	) {
		afterNextRender(() => {
			if ( isPlatformBrowser( this._platformId ) ) {
				this._router.events
				.pipe( filter( ( event: Event ) => event instanceof NavigationEnd ))
				.subscribe(() => {
					// Scroll to top after navigation
					if ( typeof window !== 'undefined' ) {
					}
				});
			}
		}, { phase: AfterRenderPhase.MixedReadWrite });
	}

	ngOnInit(): void {
		this._pseudoCustom();
	}

	private _pseudoCustom(): void {
		const style =
			document.createElement('style');

		style.textContent = `
			::view-transition-old(root),
			::view-transition-new(root) {
				animation-duration: .3s;
			}
		`;
		document.head.appendChild(style);
	}
}
